import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'

export const CreateOrganizationModalBody: React.FC = () => {
  return (
    <>
      <CIMSFormItem
        name="name"
        label="Name"
        help={HelpMessage.RequestsForInformation.Organizations.Name}
        requiredMessage="Please enter a name"
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        name="description"
        label="Description"
        help={HelpMessage.Description('Organization')}
      >
        <Input />
      </CIMSFormItem>
    </>
  )
}
